// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  googleAnalyticsId: "G-9G1B0B4BDW",
  prefixDomain: "",
  production: false,
  editorVoiceId: 1,
  ticketFeature: false,
  serviceWorker: false,
  stripe: {
    publishableKey: "pk_test_51PbGI7AVLQdlyDRHijfvhQIchtIaIz8lcj9lyWAP8H9WJd1tiuExUDNGjQDCjS9p9DUCAS8SRZTfuJouRjwXP83y007OYV9qug",
  },
  //apiUrl: 'http://192.168.19.121:3003',
  apiUrl: "https://hurtigruten-api-dev.cameralla.no",
  callbackToken: "gypq4UhOXQ2JlhLmJzE3s94AdSr3vV1XKCKN8Asp",
  mockApiUrl: "http://10.0.0.190:3003",
  socket: "hurtigruten-socket-dev.cameralla.no",
  site: "https://hurtigruten-dev.cameralla.no/",
  memberSite: "http://localhost/members/",
  header_footer_link: {
    membership: "https://courses.cameralla.club/memberships",
    course: "https://courses.cameralla.club/membership-premium",
    about_us: "http://web-cameralla.app.contemi.com.vn/om-oss/",
    contact: "http://web-cameralla.app.contemi.com.vn/kontakt",
    course_portal: "https://courses.cameralla.club/course-portal",
  },
  canon_header_footer_link: {
    membership: "https://courses.cameralla.club/memberships",
    course: "https://courses.cameralla.club/membership-premium",
    about_us: "http://web-cameralla.app.contemi.com.vn/about-us/",
    contact: "http://web-cameralla.app.contemi.com.vn/contact",
    course_portal: "https://courses.cameralla.club/Canon",
  },
  auth: {
    type: "by-pass",
    settings: {
      tokenUrl: "http://localhost:7075/gateway-api/oauth/token",
      userInfoUrl: "http://localhost:7075/gateway-api/profile",
      user_type: "Staff",
      client_id: "testclient",
      client_secret: "testpass",
      grant_type: "password",
    },

    //Eric test
    // user: {
    //     wp_id: 130,
    //     id: 130,
    //     access_token : 'nppfsdbatmzeccugpscfdt6b8z6xihcvazkxgpfz'
    // },

    //Contemi VN
    user: {
      wp_id: 1,
      id: 2,
      access_token: "xk6dwmz9k77e6pyqmkvjowqunkjza7kpxhppciap",
    },

    // Gaurav123 test
    // user: {
    //     wp_id: 32,
    //     id: 3,
    //     access_token : 'jqh2gqfer2thrbdu0peaalnoirzkc9isfkbnmylv'
    // },
  },
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
